import Membership from './Membership';
import Activated from './Activated';
import EAP from './EAP';
import PasswordGeneration from './SFTP/PasswordGeneration';
import IESunset from './Warning/IESunset';
import ServerError from './Error/ServerError';
import PageNotFound from './Error/PageNotFound';
import ManyRequests from './Error/ManyRequests';

export default {
    Membership,
    Activated,
    EAP,
    PasswordGeneration,
    IESunset,
    ServerError,
    PageNotFound,
    ManyRequests
};
